import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Loadable } from '@/components/loaders';

type RecapItemProps = {
  icon: ReactNode;
  label: ReactNode;
  labelWrapperClassName?: string;
  isLoading?: boolean;
};

export const RecapItem: FC<RecapItemProps> = ({ icon, label, labelWrapperClassName, isLoading }) => {
  return (
    <li className='flex gap-2 px-2 py-[18px]'>
      {icon}
      <Loadable className='w-3 grow-0' spinnerClassName='size-3' isLoading={isLoading}>
        <div className={twMerge('text-sm text-tertiary-600', labelWrapperClassName)}>{label}</div>
      </Loadable>
    </li>
  );
};
